export default{
    get_claim_public: state => state.claim_public,
    get_claim_public_filters: state => state.claim_public_filters,
}
